import { api } from "@/api/axios.ts";
import {
  ApiEmployeeHomeLayoutSetting,
  ApiEmployeeHomeLayoutSettingPayload,
  ApiEmployeeJobsPinsSetting,
  ApiEmployeeJobsPinsSettingPayload,
} from "@/types/employee-settings.types.ts";
import {
  ApiNotificationsSetting,
  ApiNotificationsSettingPayload,
} from "@/types/notification.types.ts";

export const apiEmployeeSettings = {
  getNotificationsSetting: async function () {
    return api.get<ApiNotificationsSetting>(`/api/v1/employee-settings/notifications`);
  },
  saveNotificationsSetting: (payload: ApiNotificationsSettingPayload) => {
    return api.put<ApiNotificationsSetting>(`/api/v1/employee-settings/notifications`, payload);
  },
  getJobsPinsSetting: async function () {
    return api.get<ApiEmployeeJobsPinsSetting>(`/api/v1/employee-settings/jobs/pins`);
  },
  saveJobsPinsSetting: (payload: ApiEmployeeJobsPinsSettingPayload) => {
    return api.put<ApiEmployeeJobsPinsSetting>(`/api/v1/employee-settings/jobs/pins`, payload);
  },
  getHomeLayout: async function () {
    return api.get<ApiEmployeeHomeLayoutSetting>(`/api/v1/employee-settings/home-layout`);
  },
  saveHomeLayout: (payload: ApiEmployeeHomeLayoutSettingPayload) => {
    return api.put<ApiEmployeeHomeLayoutSetting>(`/api/v1/employee-settings/home-layout`, payload);
  },
  resetHomeLayout: () => {
    return api.delete<ApiEmployeeHomeLayoutSetting>(`/api/v1/employee-settings/home-layout`);
  },
};
